
import { defineComponent, ref, Ref, inject, computed, nextTick, onMounted } from "vue";
import { store } from "@/store";
import CloseSVG from "@/components/CloseSVG.vue";
import { ActionTypes } from "@/store/actions";
import { LabelSizes, CurrentLabel } from "@/types";

export default defineComponent({
  components: {
    CloseSVG,
  },
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    const currentLabel = computed<CurrentLabel>(() => store.state.currentLabel);
    const labelSizes = computed<LabelSizes[]>(() =>
      store.getters.labelSizes
        .filter((label: LabelSizes) => label.svg_id !== "0" && label.label_id !== 0)
        .sort((a: LabelSizes, b: LabelSizes) => {
          if (Number(a.width!) > Number(b.width!)) {
            return 1;
          } else {
            return -1;
          }
        })
    );

    onMounted(() => {
      const foundSize = labelSizes.value.find(
        (label: LabelSizes) => label.name === currentLabel.value.label_name
      );

      if (foundSize && foundSize.label_id) {
        const sizeContainer = document.getElementById(foundSize.label_id.toString());

        if (sizeContainer) {
          sizeContainer.style.background = "#0096ff15";

          const listContainer = document.getElementById("modal-sizes-container");

          if (listContainer) {
            const sizeContainerBoundingRect = sizeContainer.getBoundingClientRect();
            const listContainerBoundingRect = listContainer.getBoundingClientRect();

            // prettier-ignore
            listContainer.scroll(0, sizeContainerBoundingRect.top - listContainerBoundingRect.top - sizeContainerBoundingRect.height / 2);
          }
        }
      }
    });

    const currentlySelectedSizeId = ref(currentLabel.value.label_id);
    const selectedLabelSize = ref({} as LabelSizes);

    const validateTarget = (target: EventTarget | null): target is HTMLInputElement => {
      return target !== null && target !== undefined;
    };

    const handleInput = async (target: EventTarget | null, id: string): Promise<void> => {
      if (validateTarget(target)) {
        const selectedLabel = target.value;
        const foundSize = labelSizes.value.find(
          (label: LabelSizes) => label.name === selectedLabel
        );

        await nextTick();
        if (foundSize) {
          const sizeContainer = document.getElementById(id);
          const prevSizeContainer = document.getElementById(
            currentlySelectedSizeId.value.toString()
          );
          if (sizeContainer && prevSizeContainer) {
            prevSizeContainer.style.background = "";

            sizeContainer.style.background = "#0096ff15";
            currentlySelectedSizeId.value = Number(id);
          }

          selectedLabelSize.value = foundSize;
        }
      }
    };

    const changeLabelSize = () => {
      store.dispatch(ActionTypes.CHANGE_LABEL_SIZE, selectedLabelSize.value);
      closeModal();
    };

    /**
     * Try to use local label asset if available, default to request from main site if not
     */
    const tryRequire = (size: any) => {
      try {
        return require(`@/assets/labels/${size.svg_id}.svg`)
      } catch (err) { // Catches code MODULE_NOT_FOUND
        if (size.svg_url)
          return size.svg_url;
        return null;
      }
    }

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
      currentLabel,
      labelSizes,
      changeLabelSize,
      handleInput,
      tryRequire,
    };
  },
});
